/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum PopupButtonEnum {
    CLOSE_POPUP = 'CLOSE_POPUP',
    DO_NOT_SHOW_AGAIN = 'DO_NOT_SHOW_AGAIN',
}
